import { TagModel } from './tagModel';

export class WrapperDataModel {
    public dataTypeId: number;
    public isToggable: boolean;
    public infoPanelType: string;
    public tagsData: Array<TagModel>;
}